import { computed, inject, Injector, Provider, runInInjectionContext, Signal } from '@angular/core';
import { B2B_PARAMS } from '@lentau/profile/shared/tokens/b2b-params.token';
import { B2BParams } from '@lentau/profile/shared/interfaces/b2b';
import { B2BLegalEntityFacade } from '@lentau/profile/organizations/legal-entity/store/service/b2b-legal-entity.facade';
import { B2bOrganizationsFacade } from '@lentau/profile/organizations/store/service/b2b-organizations.facade';
import { IS_B2B } from '@lentau/profile/organizations/legal-entity/shared/tokens/is-b2b-profile.token';
import { PASSPORT_ID } from '@lentau/profile/organizations/legal-entity/shared/tokens/passport-id.token';
import { LegalEntityResponse } from 'angular-api-gateway/v1/model/legalEntityResponse';
import { LegalEntityListItem } from 'angular-api-gateway/v1/model/legalEntityListItem';

const createB2bParamsSignal: () => Signal<B2BParams | object> = () => {
  const b2bLegalEntityFacade: B2BLegalEntityFacade = inject(B2BLegalEntityFacade);
  const passportId: Signal<string> = inject(PASSPORT_ID);
  const b2bOrganizationFacade: B2bOrganizationsFacade = inject(B2bOrganizationsFacade);

  return computed(() => {
    const legalEntityData: LegalEntityResponse = b2bLegalEntityFacade.legalEntityData();
    const userRole: string = b2bOrganizationFacade
      .selectOrganizations()
      ?.find((organization: LegalEntityListItem) => organization.legalEntityId === legalEntityData.legalEntityId)?.role;

    return {
      inn: legalEntityData.inn,
      kpp: legalEntityData.kpp,
      form: legalEntityData.form,
      legalEntityId: legalEntityData.legalEntityId,
      proCardNumber: legalEntityData.proCardNumber,
      passportId: passportId(),
      person_uid: legalEntityData.owner.siebelId,
      siebelId: legalEntityData.siebelId,
      role: userRole,
      regDate: String(legalEntityData.regDate),
      edo: String(legalEntityData.edo),
      egais: String(legalEntityData.egais),
    };
  });
};

const b2bParamsFactory: () => Signal<B2BParams | object> = () => {
  const isB2B: Signal<boolean> = inject(IS_B2B);
  const injector: Injector = inject(Injector);
  let b2bParamsSignal: Signal<B2BParams | object> | null = null;

  return computed(() => {
    if (!isB2B()) {
      return {};
    }

    b2bParamsSignal ??= runInInjectionContext(injector, createB2bParamsSignal);

    return b2bParamsSignal();
  });
};

export const B2B_PARAMS_PROVIDER: Provider[] = [
  {
    provide: B2B_PARAMS,
    useFactory: b2bParamsFactory,
  },
];
